export default __webpack_public_path__ + "static/bg-k-platform-sharing-a4d236231d4490986528a9251a6e6950.jpg";